import type {
  dealerSearchOutgoingInternal,
  useAccountSearchResult
} from "./types";
import type { dealerSearchIncoming } from "./dealerSearchIncoming";

export const defaultFilters: dealerSearchIncoming = {
  ids: [],
  accountTypes: [],
  controlCenterPlatforms: [],
  countries: [],
  names: [],
  states: [],
  urls: [],
  verticalTypes: [],
  statuses: [],
  resources: {
    matchAny: [],
    matchAll: [],
    matchNone: []
  },
  dealerCodes: {
    matchAll: []
  },
  postalCodes: [],
  franchises: {
    matchAny: [],
    matchAll: [],
    matchNone: []
  }
};

export const accountSearchResultExample: useAccountSearchResult = {
  isSearchDefault: true,
  accountSearchResult: {
    totalHits: 1,
    hits: [
      {
        key: "test-key",
        id: "test-id",
        name: "test-name",
        url: "test-url",
        franchiseList: ["test", "test2"],
        type: "DEMO",
        verticalType: "ASSOCIATION",
        status: "ACTIVE",
        city: "test-city",
        country: "USA",
        state: "AK",
        created: "2021-06-01T18:00:00.000Z",
        dealerCodes: [],
        grantedResources: []
      }
    ],
    from: 0,
    size: 1
  },
  searchRequest: defaultFilters,
  accountSearchLoading: false,
  accountSearchError: null,
  page: 1,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setPage: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setSearchRequest: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setSize: () => {},
  size: 1
};

export const exampleResponse: dealerSearchOutgoingInternal = {
  from: 0,
  size: 10,
  totalHits: 83,
  hits: [
    {
      id: "bestmatchnewdealertestingtheatlanta",
      name: "Best Match New Dealer- testing the dealer name max length",
      url: null,
      status: "IN_PRODUCTION",
      created: "2020-04-21T09:38:26.000+00:00",
      address: {
        address1: null,
        postalCode: null,
        city: "ATLANTA",
        state: "GA",
        country: "USA"
      },
      verticalType: "AUTOMOTIVE_DEALERSHIP_GROUP",
      type: "CLIENT",
      franchiseList: ["Chevrolet", "BMW", "Toyota"],
      grantedResources: [
        "UserManager",
        "AccountInfo",
        "Advertising.UAD.Dashboard",
        "AT.KBB.Reporting"
      ],
      dealerCodes: [
        {
          code: "2000155084",
          type: "at-kbb"
        },
        {
          code: "2000155084",
          type: "unique_svoc_to_sa"
        }
      ]
    },
    {
      id: "bestmatchnewdealertestingthedealern",
      name: "Best Match New Dealer- testing the dealer name max length",
      url: null,
      status: "IN_PRODUCTION",
      created: "2017-11-05T17:08:41.000+00:00",
      address: {
        address1: null,
        postalCode: null,
        city: "ATLANTA",
        state: "GA",
        country: "USA"
      },
      verticalType: "AUTOMOTIVE_FRANCHISE_DEALERSHIP",
      type: "CLIENT",
      franchiseList: ["BMW"],
      grantedResources: ["UserManager", "AccountInfo"],
      dealerCodes: [
        {
          code: "2000155084",
          type: "at-kbb"
        }
      ]
    },
    {
      id: "cbmarchaccttestingaoa",
      name: "cb march acct test",
      url: null,
      status: "IN_PRODUCTION",
      created: "2024-03-26T18:28:21.000+00:00",
      address: {
        address1: null,
        postalCode: null,
        city: "Burlington",
        state: "VT",
        country: "USA"
      },
      verticalType: "AUTOMOTIVE_FRANCHISE_DEALERSHIP",
      type: "CLIENT",
      franchiseList: [],
      grantedResources: ["UserManager", "AccountInfo"],
      dealerCodes: []
    },
    {
      id: "cbtestingaccount",
      name: "c_btest",
      url: null,
      status: "ACTIVE",
      created: "2023-08-04T19:41:04.000+00:00",
      address: {
        address1: null,
        postalCode: null,
        city: null,
        state: null,
        country: null
      },
      verticalType: "AUTOMOTIVE_FRANCHISE_DEALERSHIP",
      type: "CLIENT",
      franchiseList: [],
      grantedResources: ["UserManager", "AccountInfo"],
      dealerCodes: [
        {
          code: "123090werf9u",
          type: "cllc"
        }
      ]
    },
    {
      id: "companyforpentesting1tc",
      name: "Company for pen testing (1)",
      url: "QAtest.autotrader.ca",
      status: "INACTIVE",
      created: "2010-01-20T00:50:03.000+00:00",
      address: {
        address1: null,
        postalCode: null,
        city: "Burnaby",
        state: "BC",
        country: "CA"
      },
      verticalType: "AUTOMOTIVE_INDEPENDENT_DEALERSHIP",
      type: "CLIENT",
      franchiseList: ["Preowned"],
      grantedResources: [
        "CC7.CoCo.Header.UserDealerName",
        "CC7.CoCo.Header.LogOut",
        "CC7.CoCo.Header.Links",
        "CC7.CoCo.Header.ApplicationNavigation",
        "CC7.CoCo.Header.Logo",
        "UserManager",
        "AccountInfo",
        "BounceManager",
        "CallListening",
        "CallTracking",
        "Contacts",
        "FinanceLeads",
        "GenericLeads",
        "InventoryReports",
        "LeadReports",
        "MediaLibrary",
        "PhoneLeads",
        "PhoneReports",
        "SmartSites",
        "SmartSites.DesignSelector",
        "SmartSites.EditMetaData",
        "SmartSites.VehicleDetails.eBrochure",
        "SpecialsLeads",
        "VehicleLeads",
        "VehiclePartsLeads",
        "VehicleServiceLeads",
        "VehicleTradeInLeads",
        "Website.Departments",
        "WebsiteReports.Advanced",
        "Website.Departments.SERVICE",
        "Website.Departments.PARTS",
        "CC7.CoCo.Header.ApplicationDebugInfo",
        "CC7.CoCo.Header.ApplicationSwitcher",
        "BulkUploaderApplet",
        "CC7.CoCo.Header.ApplicationDebugInfo",
        "CC7.CoCo.Header.Help",
        "CC7.CoCo.Header"
      ],
      dealerCodes: [
        {
          code: "20090706142632011",
          type: "tc"
        },
        {
          code: "QAtest",
          type: "tcshortcode"
        },
        {
          code: "24372",
          type: "dtid"
        }
      ]
    },
    {
      id: "coxautomationtestinginc",
      name: "Cox Automation Testing Inc.",
      url: "",
      status: "ACTIVE",
      created: "2017-09-22T13:33:06.000+00:00",
      address: {
        address1: null,
        postalCode: null,
        city: "",
        state: "",
        country: ""
      },
      verticalType: "AUTOMOTIVE_DEALERSHIP_GROUP",
      type: "TEST",
      franchiseList: [],
      grantedResources: [
        "Inventory.PriceConfiguration",
        "Inventory.Manager",
        "SmartSites.FinanceApplication.DealerTrack",
        "Analytics.IntegratedDigitalRetailingReports",
        "InventoryLifecycles",
        "SmartSites.PaymentCalculator.DealerTrack",
        "LeadMachine",
        "LeadMachineLite",
        "SmartSites.TradeDriver.DealerTrack",
        "SmartSites.Social.Smartbar",
        "FleetUsedVehicles",
        "SmartSites.DesignSelector",
        "SmartSites.EditMetaData",
        "Advertising.Display.ManagedProgramAccess",
        "IncentivesManager",
        "SmartSites.FormBuilder",
        "SmartSites.Incentives",
        "SmartSites.MobileSites",
        "SmartSites.MobileSites.v2",
        "SmartSites.ModelSpecificLandingPages",
        "InventoryExports",
        "CallTracking",
        "CampaignTracking",
        "CarFax",
        "SmartSites.SiteBuilder",
        "ItemFinder",
        "ItemLeads",
        "SmartSites.Specials.Certified",
        "SmartSites.Specials.Finance",
        "LeadReports",
        "SmartSites.Specials.Generic",
        "SmartSites.Specials.Incentive",
        "SmartSites.Specials.NewVehicle",
        "SmartSites.Specials.Parts",
        "SmartSites.Specials.Preowned",
        "SmartSites.Specials.Rebate",
        "SmartSites.Specials.Service",
        "ContactImport",
        "Craigslist",
        "MediaLibrary.Flash",
        "MediaLibrary.Video",
        "SmartSites.Video.Blogging",
        "SmartSites.Video.Gallery",
        "Data.Incentives",
        "PhoneLeads",
        "SmartSites.Video.Slides",
        "PhoneReports",
        "Data.Provider.Edmunds",
        "Data.Provider.Evox",
        "Data.Provider.NewCarTestDrive",
        "Data.Provider.Video.CarFlix2.New",
        "Data.Provider.Video.CarFlix2.New.Process",
        "Data.Provider.Video.CarFlix2.Used",
        "Data.Provider.Video.CarFlix2.Used.Process",
        "Data.Provider.Video.CarFlixFX",
        "DisplayAdvertising.BasicAccess",
        "SmartSites.Blogging",
        "VideoConfig",
        "VideoExport",
        "VirtualTestDriveNew",
        "VirtualTestDriveUsed",
        "SmartSites.Commenting.AutoComments.New",
        "SmartSites.Commenting.AutoComments.Used",
        "SmartSites.Commenting.Vehicles",
        "SmartSites.Commenting.Video",
        "WholesaleConfig",
        "SmartSites.CustomCss",
        "WholesaleNewStockPhotos",
        "WholesaleNewVehicles",
        "FleetConfig",
        "SmartSites.CustomEVoxPerspectives",
        "WholesaleUsedStockPhotos",
        "FleetNewStockPhotos",
        "WholesaleUsedVehicles",
        "FleetNewVehicles",
        "WindowStickers",
        "FleetUsedStockPhotos",
        "SmartSites.MyCars.v2",
        "SmartSites.SecureLogin",
        "SmartSites.DomainSSL",
        "CC7.CoCo.Header",
        "CC7.CoCo.Header.ApplicationNavigation",
        "CC7.CoCo.Header.ApplicationSwitcher",
        "CC7.CoCo.Header.Links",
        "CC7.CoCo.Header.Logo",
        "CC7.CoCo.Header.LogOut",
        "CC7.CoCo.Header.UserDealerName",
        "CC7.CoCo.Header",
        "CC7.CoCo.Header.ApplicationNavigation",
        "CC7.CoCo.Header.ApplicationSwitcher",
        "CC7.CoCo.Header.Links",
        "CC7.CoCo.Header.Logo",
        "CC7.CoCo.Header.LogOut",
        "CC7.CoCo.Header.UserDealerName",
        "CC7.CoCo.Header",
        "CC7.CoCo.Header.ApplicationNavigation",
        "CC7.CoCo.Header.ApplicationSwitcher",
        "CC7.CoCo.Header.Links",
        "CC7.CoCo.Header.Logo",
        "CC7.CoCo.Header.LogOut",
        "CC7.CoCo.Header.UserDealerName",
        "SmartSites.JavascriptEnabler",
        "SmartSites.JavascriptEnabler",
        "CC7.CoCo.Header.Help",
        "CC7.CoCo.Header.ApplicationDebugInfo",
        "CC7.CoCo.Header.ApplicationDebugInfo",
        "SmartSites.JavascriptEnabler",
        "CC7.CoCo.Header.Help",
        "CC7.CoCo.Header.ApplicationDebugInfo",
        "CC7.CoCo.Header.AccountSwitcher",
        "CC7.CoCo.Header.Help",
        "CC7.CoCo.Header.AccountSwitcher",
        "Data.Provider.Dealertrack",
        "UserManager",
        "AccountInfo",
        "UpgradeCenter",
        "BounceManager",
        "Powermail",
        "WebsiteReports.Advanced",
        "Calendar",
        "Quotefactory",
        "Data.VinExplosion",
        "Data.Provider.Autodata",
        "MediaLibrary",
        "Contacts",
        "FinanceLeads",
        "VehicleLeads",
        "VehicleServiceLeads",
        "SpecialsLeads",
        "VehicleTradeInLeads",
        "VehiclePartsLeads",
        "GenericLeads",
        "Store",
        "Products",
        "Orders",
        "InventoryReports",
        "ColorStockPhotos",
        "PublishRulesFeedAttributes",
        "Inventory.Dashboard80",
        "Inventory.HealthScorecards",
        "PrimaryConfig",
        "PrimaryNewStockPhotos",
        "PrimaryUsedStockPhotos",
        "PrimaryNewVehicles",
        "PrimaryUsedVehicles",
        "SmartSites",
        "SmartSites.MyCars",
        "SmartSites.VirtualShowroom",
        "SmartSites.CustomEntryCoupons",
        "SmartSites.CustomExitCoupons",
        "SmartSites.BubbleAds",
        "SmartSites.SmartSpecials",
        "SmartSites.RememberMe",
        "SmartSites.VehicleDetails.eBrochure",
        "SmartSites.VehicleDetails.JatoData",
        "SmartSites.PageBuilder",
        "Website.Departments",
        "Website.Departments.Specials.FeaturedVehicles",
        "CC7.CoCo.Header",
        "CC7.CoCo.Header.ApplicationDebugInfo",
        "CC7.CoCo.Header.ApplicationNavigation",
        "CC7.CoCo.Header.ApplicationSwitcher",
        "CC7.CoCo.Header.Help",
        "CC7.CoCo.Header.Links",
        "CC7.CoCo.Header.LogOut",
        "CC7.CoCo.Header.Logo",
        "CC7.CoCo.Header.UserDealerName",
        "SmartSites.FinanceApplication.DealerTrack",
        "Analytics.IntegratedDigitalRetailingReports",
        "InventoryLifecycles",
        "SmartSites.PaymentCalculator.DealerTrack",
        "LeadMachine",
        "LeadMachineLite",
        "SmartSites.TradeDriver.DealerTrack",
        "SmartSites.Social.Smartbar",
        "FleetUsedVehicles",
        "SmartSites.DesignSelector",
        "SmartSites.EditMetaData",
        "Advertising.Display.ManagedProgramAccess",
        "IncentivesManager",
        "SmartSites.FormBuilder",
        "SmartSites.Incentives",
        "SmartSites.MobileSites",
        "SmartSites.MobileSites.v2",
        "SmartSites.ModelSpecificLandingPages",
        "InventoryExports",
        "CallTracking",
        "CampaignTracking",
        "CarFax",
        "SmartSites.SiteBuilder",
        "ItemFinder",
        "ItemLeads",
        "SmartSites.Specials.Certified",
        "SmartSites.Specials.Finance",
        "LeadReports",
        "SmartSites.Specials.Generic",
        "SmartSites.Specials.Incentive",
        "SmartSites.Specials.NewVehicle",
        "SmartSites.Specials.Parts",
        "SmartSites.Specials.Preowned",
        "SmartSites.Specials.Rebate",
        "SmartSites.Specials.Service",
        "ContactImport",
        "Craigslist",
        "MediaLibrary.Flash",
        "MediaLibrary.Video",
        "SmartSites.Video.Blogging",
        "SmartSites.Video.Gallery",
        "Data.Incentives",
        "PhoneLeads",
        "SmartSites.Video.Slides",
        "PhoneReports",
        "Data.Provider.Evox",
        "Data.Provider.NewCarTestDrive",
        "Data.Provider.Video.CarFlix2.New",
        "Data.Provider.Video.CarFlix2.New.Process",
        "Data.Provider.Video.CarFlix2.Used",
        "Data.Provider.Video.CarFlix2.Used.Process",
        "Data.Provider.Video.CarFlixFX",
        "DisplayAdvertising.BasicAccess",
        "SmartSites.Blogging",
        "VideoConfig",
        "VideoExport",
        "VirtualTestDriveNew",
        "VirtualTestDriveUsed",
        "SmartSites.Commenting.AutoComments.New",
        "SmartSites.Commenting.AutoComments.Used",
        "SmartSites.Commenting.Vehicles",
        "SmartSites.Commenting.Video",
        "WholesaleConfig",
        "SmartSites.CustomCss",
        "WholesaleNewStockPhotos",
        "WholesaleNewVehicles",
        "FleetConfig",
        "SmartSites.CustomEVoxPerspectives",
        "WholesaleUsedStockPhotos",
        "FleetNewStockPhotos",
        "WholesaleUsedVehicles",
        "FleetNewVehicles",
        "WindowStickers",
        "FleetUsedStockPhotos",
        "SmartSites.MyCars.v2",
        "SmartSites.SecureLogin",
        "SmartSites.DomainSSL",
        "CC7.CoCo.Header",
        "CC7.CoCo.Header.ApplicationNavigation",
        "CC7.CoCo.Header.ApplicationSwitcher",
        "CC7.CoCo.Header.Links",
        "CC7.CoCo.Header.Logo",
        "CC7.CoCo.Header.LogOut",
        "CC7.CoCo.Header.UserDealerName",
        "CC7.CoCo.Header",
        "CC7.CoCo.Header.ApplicationNavigation",
        "CC7.CoCo.Header.ApplicationSwitcher",
        "CC7.CoCo.Header.Links",
        "CC7.CoCo.Header.Logo",
        "CC7.CoCo.Header.LogOut",
        "CC7.CoCo.Header.UserDealerName",
        "CC7.CoCo.Header",
        "CC7.CoCo.Header.ApplicationNavigation",
        "CC7.CoCo.Header.ApplicationSwitcher",
        "CC7.CoCo.Header.Links",
        "CC7.CoCo.Header.Logo",
        "CC7.CoCo.Header.LogOut",
        "CC7.CoCo.Header.UserDealerName",
        "SmartSites.JavascriptEnabler",
        "SmartSites.JavascriptEnabler",
        "CC7.CoCo.Header.Help",
        "CC7.CoCo.Header.ApplicationDebugInfo",
        "CC7.CoCo.Header.ApplicationDebugInfo",
        "SmartSites.JavascriptEnabler",
        "CC7.CoCo.Header.Help",
        "CC7.CoCo.Header.ApplicationDebugInfo",
        "CC7.CoCo.Header.AccountSwitcher",
        "CC7.CoCo.Header.Help",
        "CC7.CoCo.Header.AccountSwitcher"
      ],
      dealerCodes: [
        {
          code: "spectredemo",
          type: "dt-dr-profile"
        },
        {
          code: "spectredemo",
          type: "dt-dr-profile"
        }
      ]
    },
    {
      id: "coxautomationtestingincchild1",
      name: "coxautomationtestingincchild1",
      url: "",
      status: "ACTIVE",
      created: "2017-09-22T16:56:16.000+00:00",
      address: {
        address1: null,
        postalCode: null,
        city: "",
        state: "",
        country: ""
      },
      verticalType: "AUTOMOTIVE_FRANCHISE_DEALERSHIP",
      type: "TEST",
      franchiseList: [],
      grantedResources: [
        "Inventory.PriceConfiguration",
        "Inventory.Manager",
        "UserManager",
        "AccountInfo",
        "UpgradeCenter",
        "BounceManager",
        "Powermail",
        "WebsiteReports.Advanced",
        "Calendar",
        "Quotefactory",
        "Data.VinExplosion",
        "Data.Provider.Autodata",
        "MediaLibrary",
        "Contacts",
        "FinanceLeads",
        "VehicleLeads",
        "VehicleServiceLeads",
        "SpecialsLeads",
        "VehicleTradeInLeads",
        "VehiclePartsLeads",
        "GenericLeads",
        "Store",
        "Products",
        "Orders",
        "InventoryReports",
        "ColorStockPhotos",
        "PublishRulesFeedAttributes",
        "Inventory.Dashboard80",
        "Inventory.HealthScorecards",
        "PrimaryConfig",
        "PrimaryNewStockPhotos",
        "PrimaryUsedStockPhotos",
        "PrimaryNewVehicles",
        "PrimaryUsedVehicles",
        "SmartSites",
        "SmartSites.MyCars",
        "SmartSites.VirtualShowroom",
        "SmartSites.CustomEntryCoupons",
        "SmartSites.CustomExitCoupons",
        "SmartSites.BubbleAds",
        "SmartSites.SmartSpecials",
        "SmartSites.RememberMe",
        "SmartSites.VehicleDetails.eBrochure",
        "SmartSites.VehicleDetails.JatoData",
        "SmartSites.PageBuilder",
        "Website.Departments",
        "Website.Departments.Specials.FeaturedVehicles",
        "CC7.CoCo.Header",
        "CC7.CoCo.Header.ApplicationDebugInfo",
        "CC7.CoCo.Header.ApplicationNavigation",
        "CC7.CoCo.Header.ApplicationSwitcher",
        "CC7.CoCo.Header.Help",
        "CC7.CoCo.Header.Links",
        "CC7.CoCo.Header.LogOut",
        "CC7.CoCo.Header.Logo",
        "CC7.CoCo.Header.UserDealerName",
        "PromotionsManager",
        "SmartSites.HTMLSlideshow"
      ],
      dealerCodes: [
        {
          code: "2001",
          type: "simsstoreid"
        },
        {
          code: "spectredemo",
          type: "dt-dr-profile"
        },
        {
          code: "spectredemo",
          type: "dt-dr-profile"
        }
      ]
    },
    {
      id: "coxautomationtestingincchild2",
      name: "coxautomationtestingincchild2",
      url: "coxautomationtestingincchild2.cms.dealer.com",
      status: "ACTIVE",
      created: "2017-09-29T14:04:41.000+00:00",
      address: {
        address1: null,
        postalCode: null,
        city: "",
        state: "CO",
        country: ""
      },
      verticalType: "AUTOMOTIVE_FRANCHISE_DEALERSHIP",
      type: "TEST",
      franchiseList: [],
      grantedResources: [
        "Inventory.PriceConfiguration",
        "Inventory.Manager",
        "UserManager",
        "AccountInfo",
        "UpgradeCenter",
        "BounceManager",
        "Powermail",
        "WebsiteReports.Advanced",
        "Calendar",
        "Quotefactory",
        "Data.VinExplosion",
        "Data.Provider.Autodata",
        "MediaLibrary",
        "Contacts",
        "FinanceLeads",
        "VehicleLeads",
        "VehicleServiceLeads",
        "SpecialsLeads",
        "VehicleTradeInLeads",
        "VehiclePartsLeads",
        "GenericLeads",
        "Store",
        "Products",
        "Orders",
        "InventoryReports",
        "ColorStockPhotos",
        "PublishRulesFeedAttributes",
        "Inventory.Dashboard80",
        "Inventory.HealthScorecards",
        "PrimaryConfig",
        "PrimaryNewStockPhotos",
        "PrimaryUsedStockPhotos",
        "PrimaryNewVehicles",
        "PrimaryUsedVehicles",
        "SmartSites",
        "SmartSites.MyCars",
        "SmartSites.VirtualShowroom",
        "SmartSites.CustomEntryCoupons",
        "SmartSites.CustomExitCoupons",
        "SmartSites.BubbleAds",
        "SmartSites.SmartSpecials",
        "SmartSites.RememberMe",
        "SmartSites.VehicleDetails.eBrochure",
        "SmartSites.VehicleDetails.JatoData",
        "SmartSites.PageBuilder",
        "Website.Departments",
        "Website.Departments.Specials.FeaturedVehicles",
        "CC7.CoCo.Header",
        "CC7.CoCo.Header.ApplicationDebugInfo",
        "CC7.CoCo.Header.ApplicationNavigation",
        "CC7.CoCo.Header.ApplicationSwitcher",
        "CC7.CoCo.Header.Help",
        "CC7.CoCo.Header.Links",
        "CC7.CoCo.Header.LogOut",
        "CC7.CoCo.Header.Logo",
        "CC7.CoCo.Header.UserDealerName",
        "PromotionsManager",
        "SmartSites.HTMLSlideshow"
      ],
      dealerCodes: [
        {
          code: "2002",
          type: "simsstoreid"
        },
        {
          code: "spectredemo",
          type: "dt-dr-profile"
        },
        {
          code: "spectredemo",
          type: "dt-dr-profile"
        }
      ]
    },
    {
      id: "coxautomationtestingincchild3",
      name: "coxautomationtestingincchild3",
      url: "coxautomationtestingincchild3.cms.dealer.com",
      status: "ACTIVE",
      created: "2017-09-29T14:09:11.000+00:00",
      address: {
        address1: null,
        postalCode: null,
        city: "",
        state: "",
        country: ""
      },
      verticalType: "AUTOMOTIVE_FRANCHISE_DEALERSHIP",
      type: "TEST",
      franchiseList: [],
      grantedResources: [
        "Inventory.PriceConfiguration",
        "Inventory.Manager",
        "UserManager",
        "AccountInfo",
        "UpgradeCenter",
        "BounceManager",
        "Powermail",
        "WebsiteReports.Advanced",
        "Calendar",
        "Quotefactory",
        "Data.VinExplosion",
        "Data.Provider.Autodata",
        "MediaLibrary",
        "Contacts",
        "FinanceLeads",
        "VehicleLeads",
        "VehicleServiceLeads",
        "SpecialsLeads",
        "VehicleTradeInLeads",
        "VehiclePartsLeads",
        "GenericLeads",
        "Store",
        "Products",
        "Orders",
        "InventoryReports",
        "ColorStockPhotos",
        "PublishRulesFeedAttributes",
        "Inventory.Dashboard80",
        "Inventory.HealthScorecards",
        "PrimaryConfig",
        "PrimaryNewStockPhotos",
        "PrimaryUsedStockPhotos",
        "PrimaryNewVehicles",
        "PrimaryUsedVehicles",
        "SmartSites",
        "SmartSites.MyCars",
        "SmartSites.VirtualShowroom",
        "SmartSites.CustomEntryCoupons",
        "SmartSites.CustomExitCoupons",
        "SmartSites.BubbleAds",
        "SmartSites.SmartSpecials",
        "SmartSites.RememberMe",
        "SmartSites.VehicleDetails.eBrochure",
        "SmartSites.VehicleDetails.JatoData",
        "SmartSites.PageBuilder",
        "Website.Departments",
        "Website.Departments.Specials.FeaturedVehicles",
        "CC7.CoCo.Header",
        "CC7.CoCo.Header.ApplicationDebugInfo",
        "CC7.CoCo.Header.ApplicationNavigation",
        "CC7.CoCo.Header.ApplicationSwitcher",
        "CC7.CoCo.Header.Help",
        "CC7.CoCo.Header.Links",
        "CC7.CoCo.Header.LogOut",
        "CC7.CoCo.Header.Logo",
        "CC7.CoCo.Header.UserDealerName",
        "PromotionsManager",
        "SmartSites.HTMLSlideshow"
      ],
      dealerCodes: [
        {
          code: "2003",
          type: "simsstoreid"
        },
        {
          code: "spectredemo",
          type: "dt-dr-profile"
        },
        {
          code: "spectredemo",
          type: "dt-dr-profile"
        }
      ]
    },
    {
      id: "coxautomationtestingincgroup",
      name: "coxautomationtestingincgroup",
      url: "",
      status: "IN_PRODUCTION",
      created: "2017-09-22T17:02:50.000+00:00",
      address: {
        address1: null,
        postalCode: null,
        city: "",
        state: "",
        country: ""
      },
      verticalType: "AUTOMOTIVE_DEALERSHIP_GROUP",
      type: "DEMO",
      franchiseList: [],
      grantedResources: ["UserManager", "AccountInfo"],
      dealerCodes: []
    }
  ]
};

export const exampleResponseBasic: dealerSearchOutgoingInternal = {
  from: 0,
  size: 3,
  hits: [
    {
      address: {
        city: "test-city",
        country: "USA",
        state: "AK",
        address1: null,
        postalCode: null
      },
      created: "2021-06-01T18:00:00.000Z",
      id: "test-id",
      name: "test-name",
      status: "ACTIVE",
      url: "test-url",
      franchiseList: ["test", "test2"],
      type: "DEMO",
      verticalType: "ASSOCIATION",
      dealerCodes: [],
      grantedResources: []
    },
    {
      address: {
        city: "test-city2",
        country: "USA",
        state: "AK",
        address1: null,
        postalCode: null
      },
      created: "2021-06-01T18:00:00.000Z",
      id: "test-id2",
      name: "test-name2",
      url: "test-url2",
      franchiseList: ["test", "test2"],
      type: "DEMO",
      verticalType: "ASSOCIATION",
      status: "ACTIVE",
      dealerCodes: [],
      grantedResources: []
    },
    {
      address: {
        city: "test-city3",
        country: "USA",
        state: "AK"
      },
      created: "2021-06-01T18:00:00.000Z",
      id: "test-id3",
      name: "test-name3",
      url: "test-url3",
      franchiseList: ["test", "test2"],
      type: "DEMO",
      verticalType: "ASSOCIATION",
      status: "ACTIVE",
      dealerCodes: [],
      grantedResources: []
    }
  ],
  totalHits: 6
};
